import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DeviceType } from 'app/data-studio-redesign/interfaces/data-studio.interface';
import { transformArray } from 'app/shared/helper/common.helper';

export interface ISeriesElement {
  name: string;
  id: string;
  selected: boolean;
  deviceType: DeviceType;
}

export interface ISeriesElementLabels {
  loading: string;
  title: string;
  all: string;
  placeholder: string;
  noMatches?: string;
  noSelection?: string;
}

@Component({
    selector: 'app-element-selector',
    templateUrl: './element-selector.component.html',
    styleUrls: ['./element-selector.component.scss'],
    standalone: false
})

export class ElementSelectorComponent implements OnChanges {

  @Input() items: ISeriesElement[];
  @Input() labels: ISeriesElementLabels;
  @Input() expanded: boolean;
  @Input() withTimer?: Boolean;
  @Input() withBlocks?: Boolean;
  @Input() withExpand?: Boolean;
  @Input() withToggle?: Boolean;
  @Input() disabled?: Boolean;
  @Input() filterOptions?: [];

  @Input() loadingData: boolean;
  @Output() itemSelect = new EventEmitter<ISeriesElement>();
  @Output() allItemsSelect = new EventEmitter<ISeriesElement[]>();
  @Output() toggleChanged = new EventEmitter<Boolean>();
  @Output() filterChanged = new EventEmitter();
  @Output() expandChanged = new EventEmitter();

  public filteredItems: ISeriesElement[];
  public filteredItemBlocks: ISeriesElement[][];
  public itemCount: number;
  public searchItemValue: string;
  public allItemsSelected = false;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes?.items?.currentValue) {
      this.searchItem(this.searchItemValue);
    }
  }

  private toBlocks() {
    this.filteredItemBlocks = transformArray(this.filteredItems, 5);
  }

  public searchItem(input) {
    this.searchItemValue = (input || '');
    this.filteredItems = this.items?.filter(item => 
      item.name.replace(/\s+/g, '').replace(/_/g, '').toLowerCase().includes(this.searchItemValue.toLowerCase().replace(/\s+/g, '')))
      
    this.toBlocks();
    this.allItemsSelected = this.filteredItems.every(item => item.selected);
  }

  public pinToggle() {
    this.toggleChanged.emit();
  }

  public toggleExpand() {
    this.expandChanged.emit();
  }

  public toggleAllItemsSelection() {
    if (this.disabled) return;

    this.allItemsSelected = !this.allItemsSelected;
    this.filteredItems.forEach(item => {
      item.selected = this.allItemsSelected;
    });
    this.allItemsSelect.emit(this.filteredItems);
  }

  public toggleItemSelection(item) {
    if (this.disabled) return;

    item.selected = !item.selected;
    this.allItemsSelected = this.filteredItems.every(item => item.selected);
    setTimeout(() => {
      this.itemSelect.emit(item);
    });
  }

  public updateFilter() {
    this.filterChanged.emit();
  }

  public trackByFn(index, item) {
    return item.id ?? index;
  }

}
